"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HegydCore = /** @class */ (function () {
    function HegydCore() {
    }
    HegydCore.initSelect2 = function (selector, options_forced) {
        if (selector === void 0) { selector = null; }
        if (options_forced === void 0) { options_forced = null; }
        if (!selector) {
            selector = 'select.selectable2, select.select2';
        }
        if (!options_forced) {
            options_forced = {};
        }
        var options_default = {
            language: 'fr'
        };
        $.extend(options_default, options_forced);
        var $selector = $(selector);
        if ($selector !== undefined && $selector.length) {
            if ($selector.length > 1) {
                $selector.each(function () {
                    var placeholder = $(this).data('placeholder');
                    if (placeholder != undefined && placeholder.length > 0) {
                        $.extend(options_default, { 'placeholder': placeholder });
                    }
                    // @ts-ignore
                    $(this).select2(options_default);
                    // Is selected items are available in data-selected as array then force them
                    var selected = $(this).data('selected');
                    if (selected != undefined && selected.length > 0) {
                        // @ts-ignore
                        $("div" + selector).select2('data', selected);
                    }
                });
            }
            else {
                // Manage default placeholder
                var placeholder = $selector.data('placeholder');
                if (placeholder != undefined && placeholder.length > 0) {
                    $.extend(options_default, { 'placeholder': placeholder });
                }
                // @ts-ignore
                $selector.select2(options_default);
                // Is selected items are available in data-selected as array then force them
                var selected = $selector.data('selected');
                if (selected != undefined && selected.length > 0) {
                    // @ts-ignore
                    $("div" + selector).select2('data', selected);
                }
            }
        }
    };
    return HegydCore;
}());
exports.default = HegydCore;
